import IDCLogo from '../icons/IDCLogo';
import { Diamond } from '../Ornaments/Diamond';
import { LightPolygon } from '../Ornaments/LightPolygon';
import { SmallCircle } from '../Ornaments/SmallCircle';
import { Star } from '../Ornaments/Star';
import { Testimonial } from './Testimonial';

export const IDC = () => {
  return (
    <Testimonial
      company={<IDCLogo height="40" />}
      quote="Transcend is frequently chosen for its technical compatibility, rapid deployment, support for hierarchical organizational structures, and proven scalability across thousands of domains in global enterprise settings."
      author={
        <>
          <span className="font-medium">Ryan O’Leary</span>, Research Director
          for Privacy and Legal Technology at IDC
        </>
      }
    >
      <SmallCircle className="absolute top-65 right-50 w-230 hidden ml:block" />
      <LightPolygon className="absolute ml:-bottom-100 -bottom-50 ml:-right-180 -right-80 ml:w-500 w-190 ml:blur-sm" />
      <Diamond className="absolute top-120 -left-50 ml:-left-250 ml:w-600 w-120 opacity-80 blur-sm" />

      <Star className="absolute ml:-top-250 -top-50 left-80 ml:left-[calc(50vw-220px)] w-160 ml:w-440" />
    </Testimonial>
  );
};
